export default __webpack_public_path__ + "static/media/question_icon.79053c32.png";